import { ResponseDataTest } from '../../../../models/responseDataTest'
import { agroApi } from '../../api'
import { ResponseDataGet } from '../../../../models/responseDataGet'
import { EntDirectoryInfoName } from '../../../../models/directoryInfoName'
import { EntTransportCategoryFilter } from '../../../../models/filters/transportCategoryFilter'
import { Paths } from '../../../../paths'

export const veterinaryProductCategoryApi = agroApi.injectEndpoints({
	endpoints: builder => ({
		getVeterinaryProductCategoryList: builder.query<
			ResponseDataGet<EntDirectoryInfoName>,
			EntTransportCategoryFilter
		>({
			query: filter => ({
				url: `${Paths.handbooks.typeOfVeterinaryCategoryProduct}/get-all`,
				method: 'POST',
				body: JSON.stringify(filter),
			}),
		}),
		getVeterinaryProductCategoryById: builder.query<ResponseDataTest<EntDirectoryInfoName>, number>(
			{
				query: id => ({
					url: `${Paths.handbooks.typeOfVeterinaryCategoryProduct}/${id}`,
					method: 'GET',
				}),
			}
		),
		addVeterinaryProductCategory: builder.mutation<
			ResponseDataTest<EntDirectoryInfoName>,
			EntDirectoryInfoName
		>({
			query: body => ({
				url: `${Paths.handbooks.typeOfVeterinaryCategoryProduct}`,
				method: 'POST',
				body: JSON.stringify(body),
			}),
		}),
		editVeterinaryProductCategory: builder.mutation<
			ResponseDataTest<EntDirectoryInfoName>,
			EntDirectoryInfoName
		>({
			query: body => ({
				url: `${Paths.handbooks.typeOfVeterinaryCategoryProduct}`,
				method: 'PUT',
				body: JSON.stringify(body),
			}),
		}),
		deleteVeterinaryProductCategory: builder.mutation<
			ResponseDataTest<EntDirectoryInfoName>,
			number
		>({
			query: id => ({
				url: `${Paths.handbooks.typeOfVeterinaryCategoryProduct}/${id}`,
				method: 'DELETE',
			}),
		}),
	}),
	overrideExisting: false,
})

export const {
	useAddVeterinaryProductCategoryMutation,
	useDeleteVeterinaryProductCategoryMutation,
	useEditVeterinaryProductCategoryMutation,
	useLazyGetVeterinaryProductCategoryListQuery,
} = veterinaryProductCategoryApi
